import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { putPoint, getSchedules, getMBMEquipments } from "services/ConfigServices";
import styled from "styled-components";
import SweetAlert from "react-bootstrap-sweetalert";
import HelpIcon from '@mui/icons-material/Help';
import { stateData, controlmodeData } from "variables/MBM/lists/equipments";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";
import TextInputWithChip from "components/Input/TextInputWithChip";
import FormulaEditor from "components/Input/FormulaEditor";
import { overwritevaluestranslation } from "variables/lists/dico";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  icon: {
    left: "5px",
    top: "30px",
    width: "17px",
    height: "17px",
    position: "relative",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#3E8FC6",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const HelpLine = styled.p`
  text-align : left;
`;


function PointDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_admin = permis.includes("mbm_geb_control_admin");

  const { closeModal, refetch, setLoading, setNotification, point, chartIdGroup, schedulesData } = props;

  const [pointsData, setPointsData] = useState([]);

  const [filteredschedulesdata, setFilteredschedulesdata] = useState([]);
  const [state, setState] = useState(point.state);
  const [controlmode, setControlmode] = useState(point.controlmode);
  const [schedule, setSchedule] = useState(point.schedule || "");
  const [points, setPoints] = useState(point.formula?.points || []);
  const [formula, setFormula] = useState(point.formula?.text || "");
  const [alert, setAlert] = React.useState(null);
  const [staticvaldata, setStaticvaldata] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleStateChange = (event) => {
    setState(event.target.value);
  };
  const handleScheduleChange = (selected) => { setSchedule(selected?.id || ""); };
  const handlePointsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setPoints(newArray);
  };
  const handleFormulaChange = (event) => { setFormula(event.target.value); };
  const handleControlmodeChange = (event) => {
    if (event.target.value === 0) //valeur constante
    {
      setFormula("");
      setPoints([]);
    }
    else if (event.target.value === 1) //planning et formule
    {
      setFormula("{schedule}");
    }
    setControlmode(event.target.value);
  };
  const handleStaticvalSelectChange = (event) => { setFormula(event.target.value); };
  const handleStaticvalTextChange = (event) => { setFormula(event.target.value); };

  const classes = useStyles();

  const selectedSchedule = () => {
    console.log(filteredschedulesdata);
    let selected = filteredschedulesdata.find((obj) => obj.id == schedule);
    if (!selected)
      selected = "";
    return selected;
  };

  useEffect(() => {
    if (point.displayproperties?.overwritevalues && Object.keys(point.displayproperties?.overwritevalues).length > 0) {
      let overvalues = point.displayproperties.overwritevalues;
      let staticvaldatatmp = Object.keys(overvalues).map((val) => {
        let data = { id: val, name: overwritevaluestranslation.find((r) => r.id === overvalues[val])?.name || overvalues[val] };
        return data;
      });
      setStaticvaldata(staticvaldatatmp);
    }
  }, [point]);

  useEffect(() => {
    if (schedulesData) {
      let tmpfilteredschedulesdata = schedulesData.filter((obj) =>
        (point.proxyid && obj.destination && obj.destination.avobboxs && obj.destination.avobboxs.includes(point.proxyid)) ||
        (point.connectionproperties.eosprotocol === 'wiotyslorawanserver' && obj.destination && obj.destination.destinationtype === 'wiotyslorawanserver') ||
        (point.connectionproperties.eosprotocol === 'avoblorawanserver' && obj.destination && obj.destination.destinationtype === 'avoblorawanserver'));
      setFilteredschedulesdata(tmpfilteredschedulesdata);
    }
  }, [schedulesData]);

  const selectedPoint = () => {
    let selected = pointsData.filter((obj) =>
      points.includes(obj.id));
    return selected;
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const getTooltipHelp = () => {
    const tooltipAlert = (
      <SweetAlert
        style={{
          fontSize: '14px',
          fontFamily: '"Source Sans Pro",sans-serif',
          color: ' #3c4858',
          display: "block", marginTop: "-50px", width: "25rem"
        }}
        title=""
        showConfirm={false}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
      >
        <div style={{ fontSize: "14px" }}>
          <p><b>Fonctions de la formule :</b></p>
          <HelpLine>{"{schedule} : la valeur du planning sur le créneau horaire"}</HelpLine>
          <HelpLine>{"{state} : la valeur actuelle du point piloté"}</HelpLine>
          <HelpLine>{"{AVG[points]} : la moyenne des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{SUM[points]} : la somme des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MIN[points]} : le plus petite des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MAX[points]} : la plus grande des valeurs des points liés"}</HelpLine>
        </div>
      </SweetAlert>
    );
    setAlert(tooltipAlert);
  };

  // useEffect(() => {
  //   let render = <Chip variant="outlined" label={formula}/>;

  // }, [formula]);

  const handleSubmit = (event) => {
    updatePoint(event);
    closeModal();
  };

  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getMBMEquipments(chartIdGroup, 'all'),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let i = 0;
          let tmpPointsData = res.data.points?.map((data) => {
            return (
              { name: data.name + " (" + data.id + ")", id: data.id }
            );
          });
          setPointsData(tmpPointsData || []);
        });
    }
  }, [chartIdGroup]);

  const updatePoint = async (event) => {
    axios
      .put(
        putPoint("policy"),
        {
          ...point,
          state,
          controlmode,
          schedule: schedule || -1,
          formula: {
            points: points,
            text: formula
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Point modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={"Etat"}
                selectValue={state}
                handleSelectValueChange={handleStateChange}
                data={stateData}
                disabled={!mbm_geb_control_admin}
              />
            </div>
            {
              state === 1 ?
                <>
                  <div>
                    <CustomSelect
                      inputTitle={"Mode de pilotage"}
                      selectValue={controlmode}
                      handleSelectValueChange={handleControlmodeChange}
                      data={controlmodeData}
                      disabled={!mbm_geb_control_admin}
                    />
                  </div>
                  {controlmode === 1 ?
                    <>
                      <div>
                        <AutocompleteInputMeters
                          specialWidth={"97%"}
                          inputMargin={"1rem 0rem 0rem"}
                          inputTitle={"Planning"}
                          selected={selectedSchedule()}
                          list={filteredschedulesdata}
                          handleChange={(_, newValue) =>
                            handleScheduleChange(newValue)
                          }
                        />
                      </div>
                      {
                        mbm_geb_control_admin ?
                          <div>
                            <AutocompleteMultiselectInputById
                              specialWidth={"97%"}
                              inputMargin={"1rem 0rem 0rem"}
                              inputTitle={"Points liés"}
                              selected={selectedPoint()}
                              list={pointsData}
                              handleChange={handlePointsChange}
                              disabled={!mbm_geb_control_admin}
                            />
                          </div> : <></>
                      }
                      <div>
                        <GridContainer>
                          <GridItem xs={11} sm={11} md={11} lg={11} className={"noPadding"}>
                            <TextInput
                              inputTitle={"Formule"}
                              textInput={formula}
                              handleTextInputChange={handleFormulaChange}
                              multiline
                              rows={4}
                              disabled={!mbm_geb_control_admin}
                            />
                          </GridItem>
                          <GridItem xs={1} sm={1} md={1} lg={1}>
                            <HelpIcon className={classes.icon} onClick={() => getTooltipHelp()} />
                          </GridItem>
                        </GridContainer>
                      </div>
                    </>
                    : controlmode === 0 ?
                      <>
                        {staticvaldata.length > 0 ?
                          <div>
                            <CustomSelect
                              inputTitle={"Valeur"}
                              selectValue={formula}
                              handleSelectValueChange={handleStaticvalSelectChange}
                              data={staticvaldata}
                              disabled={!mbm_geb_control_admin}
                            />
                          </div> :
                          <div>
                            <TextInput
                              inputTitle={"Valeur"}
                              textInput={formula}
                              handleTextInputChange={handleStaticvalTextChange}
                              disabled={!mbm_geb_control_admin}
                            />
                          </div>
                        }
                      </> :
                      <></>
                  }
                </>
                :
                <></>
            }
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
      {alert}
    </>
  );
}

export default PointDialog;
